<div class="cookies-consent-container">
    <div class="cookies-consent-content">
      <h2>Cookies Policy</h2>
      <p>This website uses cookies to ensure you get the best experience on our website.</p>
      <p>By continuing to use this site, you agree to our use of cookies.</p>
      <div class="buttons">
        <button class="btn btn-green btn-accept" (click)="acceptCookies(true)">Accept</button>
        <button class="btn btn-outline btn-decline" (click)="declineCookies(false)">Decline</button>
      </div>
    </div>
</div>
      